// import { Outlet, Link } from 'react-router-dom';
// import { useAuth } from '../contexts/AuthContext';

// export const AppLayout = () => {
//   const { role, profile, signOut } = useAuth();

//   const links = role === 'ADMIN'
//     ? [
//         { to: '/admin', label: 'Dashboard' },
//         { to: '/admin/contacts', label: 'Contacts' },
//         { to: '/admin/requests', label: 'Requests' },
//         { to: '/admin/employees', label: 'Employees' },
//         { to: '/admin/shivars', label: 'Shivars' },
//         { to: '/admin/users', label: 'Users' },
//         { to: '/admin/audit-logs', label: 'Audit Logs' },
//       ]
//     : [
//         { to: '/employee', label: 'Dashboard' },
//         { to: '/employee/add-number', label: 'Add Number' },
//         { to: '/employee/requests', label: 'My Requests' },
//       ];

//   return (
//     <div className="min-h-screen bg-gray-50">
//       <header className="bg-white shadow-sm">
//         <div className="mx-auto flex max-w-7xl items-center justify-between px-4 py-4">
//           <Link to="/" className="text-xl font-bold text-blue-700">
//             📞 Tandulwadi Phone Book
//           </Link>
//           <div className="flex items-center gap-4">
//             <span className="hidden text-sm text-gray-600 md:inline">
//               {profile?.full_name} <span className="rounded bg-gray-100 px-2 py-0.5 text-xs font-medium">{role}</span>
//             </span>
//             <button
//               onClick={() => signOut()}
//               className="rounded bg-gray-200 px-3 py-1.5 text-sm font-medium text-gray-800 hover:bg-gray-300"
//             >
//               Logout
//             </button>
//           </div>
//         </div>
//         <nav className="mx-auto max-w-7xl border-b border-gray-200 px-4">
//           <ul className="flex gap-6 overflow-x-auto">
//             {links.map((link) => (
//               <li key={link.to}>
//                 <Link
//                   to={link.to}
//                   className="block border-b-2 border-transparent py-2 text-sm font-medium text-gray-700 hover:border-blue-500 hover:text-blue-700"
//                 >
//                   {link.label}
//                 </Link>
//               </li>
//             ))}
//           </ul>
//         </nav>
//       </header>
//       <main className="mx-auto max-w-7xl px-4 py-6">
//         <Outlet />
//       </main>
//     </div>
//   );
// };
import { Outlet, Link } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { FlipWords } from '../components/velora/flip-words';

export const AppLayout = () => {
  const { role, profile, signOut } = useAuth();

  const links =
    role === 'ADMIN' || role === 'SUPERADMIN'
      ? [
          { to: '/admin', label: 'Dashboard' },
          { to: '/phone-book', label: 'Phone Book' },
          { to: '/admin/contacts', label: 'Contacts' },
          { to: '/admin/requests', label: 'Requests' },
          { to: '/admin/employees', label: 'Employees' },
          { to: '/admin/shivars', label: 'Shivars' },
          { to: '/admin/users', label: 'Users' },
          { to: '/admin/contact-messages', label: 'Contact Messages' },
          { to: '/admin/audit', label: 'Audit' },
        ]
      : role === 'EMPLOYEE'
      ? [
          { to: '/employee', label: 'Dashboard' },
          { to: '/phone-book', label: 'Phone Book' },
          { to: '/employee/add-number', label: 'Add Number' },
          { to: '/employee/contacts', label: 'Contact List' },
          { to: '/employee/requests', label: 'Contact Requests' },
          { to: '/employee/user-approvals', label: 'User Approvals' },
        ]
      : [
          { to: '/phone-book', label: 'Phone Book' },
          { to: '/add-contact', label: 'Add Contact Request' },
        ];

  return (
    <div className="min-h-screen bg-gray-50">
      {/* Header */}
      <header className="bg-white shadow-sm">
        {/* Top Header */}
        <div className="mx-auto flex max-w-7xl items-center justify-between px-4 py-4">
          
          {/* Logo + Application Name */}
          <Link
            to="/"
            className="flex items-center gap-3 text-xl font-bold text-blue-700"
          >
            <img
              src="/static/logo.png"
              alt="Tandulwadi Phone Book"
              className="h-10 w-10 object-contain"
            />

            <span className="leading-tight">
              <FlipWords
                words={['Tandulwadi', 'तांदुळवाडी']}
                duration={5000}
              />{' '}
              Phone Book
            </span>
          </Link>

          {/* User Information + Logout */}
          <div className="flex items-center gap-4">
            <span className="hidden text-sm text-gray-600 md:inline">
              {profile?.full_name}{' '}
              <span className="rounded bg-gray-100 px-2 py-0.5 text-xs font-medium">
                {role}
              </span>
            </span>

            <button
              onClick={() => signOut()}
              className="rounded bg-gray-200 px-3 py-1.5 text-sm font-medium text-gray-800 hover:bg-gray-300"
            >
              Logout
            </button>
          </div>
        </div>

        {/* Navigation */}
        <nav className="mx-auto max-w-7xl border-b border-gray-200 px-4">
          <ul className="flex gap-6 overflow-x-auto">
            {links.map((link) => (
              <li key={link.to}>
                <Link
                  to={link.to}
                  className="block border-b-2 border-transparent py-2 text-sm font-medium text-gray-700 hover:border-blue-500 hover:text-blue-700"
                >
                  {link.label}
                </Link>
              </li>
            ))}
          </ul>
        </nav>
      </header>

      {/* Page Content */}
      <main className="mx-auto max-w-7xl px-4 py-6">
        <Outlet />
      </main>
    </div>
  );
};